export default __webpack_public_path__ + "static/media/logow.24ba76ae.png";